export default class ValidationService {
	validateEmail(email) {
		//eslint-disable-next-line
		const REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i;
		return REGEX.test(email);
	}

	validateURL(url) {
		//eslint-disable-next-line
		const REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
		return REGEX.test(url);
	}

	validateName(name) {
		//eslint-disable-next-line
		const REGEX = /^[a-z0-9.-]*$/;
		return REGEX.test(name);
	}

	validateField(field) {
		//eslint-disable-next-line
		const REGEX = /^[A-Za-z0-9_-]*$/;
		return REGEX.test(field);
	}

	validateQueryName(field) {
		//eslint-disable-next-line
		const REGEX = /^[A-Za-z0-9]*$/;
		return REGEX.test(field);
	}

	validatePassword(pass) {
		const REGEX = /(?=^.{8,15}$)((?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=(.*\d){1,}))((?!.*[",;&|'])|(?=(.*\W){1,}))(?!.*[",;&|'])^.*$/;
		return REGEX.test(pass);
	}
}



// WEBPACK FOOTER //
// ./src/services/ValidationService.js